import React from "react";
import "./Oops.css";

function Oops() {
  return (
    <div className="oopsie">
      <div>
        <h1>404</h1>
        <h2>
          YOU SEE...NOW YOU SEE THERE...YOU KNOW YOU DONE FUGGED UP, DON'T YA?
        </h2>
      </div>
    </div>
  );
}

export default Oops;
